import "./style.scss";
import { FC } from "react";

export interface DocumentCheckActionButtonsProps {
  onApprove?: () => void;
  onReject?: () => void;
  onToCorrect?: () => void;
  /** Horizontal row (preview modal) or vertical stack (header selector). */
  layout?: "row" | "column";
}

const DocumentCheckActionButtons: FC<DocumentCheckActionButtonsProps> = ({
  onApprove,
  onReject,
  onToCorrect,
  layout = "row",
}) => {
  const hasActions = Boolean(onApprove || onReject || onToCorrect);
  if (!hasActions) return null;

  return (
    <div className={`document-check-action-buttons ${layout}`}>
      {onApprove && (
        <button type="button" className="document-check-action-buttons-item approve" onClick={onApprove}>
          Approved
        </button>
      )}
      {onReject && (
        <button type="button" className="document-check-action-buttons-item reject" onClick={onReject}>
          Reject
        </button>
      )}
      {onToCorrect && (
        <button type="button" className="document-check-action-buttons-item to-correct" onClick={onToCorrect}>
          To Correct
        </button>
      )}
    </div>
  );
};

export default DocumentCheckActionButtons;
